export default {
  mensajes: {
    inicial: 'Hi!',
    descripcion: 'Request your quote easily and quickly in just three steps.',
    resumen: 'View summary',
  
    datos_de_reserva: 'Booking details',
    datos_personales: 'Personal information',
    resumen_reserva: 'Your quote has been sent!',
  
    preguntaPaso1: 'We need the following basic information to arrange your camino: arrival date, number of pilgrims, and number of rooms by type.',
  
    datos_reserva: {
      fechas_seleccion: 'Arrival and departure date',
      
      habitaciones_individuales: 'Single rooms',
      habitaciones_dobles: 'Double rooms (2_single_beds)',
      habitaciones_dobles_matrimoniales: 'Double rooms (1_matrimonial_bed)',
      habitaciones_triples: 'Triple rooms',
      cantidad_de_peregrinos: 'Number of pilgrims',

      titulo: 'Booking details',
      fecha_inicio: 'Arrival date:',
      fecha_llegada: 'Departure date:',
      habitaciones: 'Rooms:',
      peregrinos: 'Pilgrims:',
      comentarios: 'Tell us any additional information.\nDo you have children? Tell us their ages.\nDo you have pets? Tell us what pet it is and its weight.',
  
      importe_reserva: 'Basic booking amount:',
      servicios_agregados: 'Additional services:',
      importe_total: 'Total amount:',
      comision_agencia: '15% Agency commission:',
      importe_neto_agencia: 'Net agency amount:',
      no_comisionable: '(Not commissionable)',
      precio_por_peregrino: '€/Pilgrim',
    },

    servicios: {
      tab_servicios: 'Services',
      incluidos_titulo: 'Included services',
      incluidos_subtitulo: 'If you want to cancel any of the included services, you can remove it.',
      opcionales_titulo: 'Optional services',
      pendiente_de_tarifa: 'Pending',
      subtitulo_desde: '(From {tarifa}€)',
      subtitulo_por_persona: '({tarifa}€ x pilgrim)',
      subtitulo_por_persona_con_persona: '({tarifa}€ x {personas} pilgrims)',
      noche_extra_en: 'Extra night in',
      traslado_extra: 'Extra transfer',
      servicio_extra: 'Extra service',
      ver_incluidos_boton: 'View included services',
    },

    siguientePaso1: 'Next',

    preguntaPaso2: 'Now we need your details to send you the quote as soon as possible.',
    nombre: 'Name',
    apellidos: 'Surname',
    telefono: 'Phonenumber',
    email: 'E-mail',

    politica_privacidad: 'I accept the ',
    politica_privacidad_texto_enlace: 'privacy policy',
    politica_privacidad_enlace: 'https://rutasmeigas.com/privacy-policy',

    acepta_novedades: 'I agree to receive latest news.',

    recibir_presupuesto: 'Receive quote',
    enviando_presupuesto: 'Sending quote...',
    presupuesto_enviado: 'QUOTE SEND!',
   
    datos_pasajeros: {
      titulo: "In accordance with current Spanish legislation (Royal Decree 933/2021 of October 26) which establishes the obligations of documentary registration and information of natural or legal persons that carry out lodging activities (travel agencies, hotel establishments and rental companies of vehicles) we must provide the following data to the Ministry of the Interior (Government of Spain).",
      subtitulo: 'To manage your booking, we need the complete details of all the pilgrims who will be participate at the Camino de Santiago. Please fill out each form with the requested information.<br>It is important that the details are accurate and complete, as we will use them to organize the trip, reserve accommodations, and other services.<br>Once you have completed all the information, we will proceed to confirm your booking. If you have any questions, please don’t hesitate to contact us.',
      datos_peregrino: 'Traveler {index}',
      confirmar_datos: 'Confirm details',
      guardar_datos: 'Save travelers data',
      mensaje_final_success: 'Thank you. The data of the travelers has been saved correctly.',
      pagar: 'Pay',
      mensaje_confirmacion_pasajero_y_pago: 'Your data has been sent correctly. We inform you that the total amount of the reservation is {importe} €.<br>You can now make a 100€ advance payment for the reservation.',
      pago_realizado: 'Payment made correctly',


      nombre: 'Name',
      primer_apellido: 'First Surname',
      segundo_apellido: 'Second Surname',
      sexo: 'Sex',
      sexo_opciones: {
        hombre: 'Male',
        mujer: 'Female',
        no_decir: 'Prefer not to say',
      },
      fecha_nacimiento: 'Date of Birth',
      tipo_documento: 'Document Type',
      tipo_documento_opciones: {
        dni: 'DNI',
        nie: 'NIE',
        pasaporte: 'Passport',
      },
      numero_documento: 'Document Number',
      soporte_documento: 'Document Support',
      telefono_fijo: 'Fixed Phone',
      telefono_movil: 'Mobile Phone',
      email: 'Email',
      direccion: 'Address',
      poblacion: 'Population',
      provincia: 'Province',
      codigo_postal: 'Postal Code',
      nacionalidad: 'Nationality',
      parentesco: 'Relationship',

      pago_realizado_subtitulo: 'Thank you for trusting us.<br>We will contact you to confirm the details of your reservation.',
      politica_privacidad: `Responsible for processing: RUTAS MEIGAS SL CIF: B15649270 Postal address: LUGAR DO BARCO 1, 15917 - PADRON (A CORUÑA) Telephone: 881019941 E-mail: info@rutasmeigas.com 
      Purpose of the processing of your data: In accordance with the provisions of current legislation on the Protection of Personal Data, Regulation 2016/679 General Data Protection Regulation (RGPD) and Organic Law 3/2018 of 5 December, on the protection of personal data and guarantee of digital rights (LOPDGDD), we inform you that the purpose of the processing of your data is to carry out the management of your reservation.
      Legitimation: Article 6.1.a) of the GDPR. The data subject consented to the processing of his or her personal data for one or more specific purposes. Article 6.1.b) of the GDPR. Processing necessary for the performance of a contract to which the data subject is a party or for the implementation at the request of the data subject of pre-contractual measures. Article 6.1.c) of the GDPR: processing is necessary for compliance with a legal obligation applicable to the controller: Royal Decree 933/2021 of 26 October establishing the documentary registration and information obligations of natural or legal persons carrying out accommodation and motor vehicle rental activities. Article 45 of the Schengen Agreement of June 1985 Organic Law 4/2015 of 30 March 2015 on the protection of citizen security.
      Conservation and treatment of data: The data provided will be kept as long as you do not request its cancellation, or for the time necessary to comply with legal obligations and to meet any possible liabilities that may arise from the fulfilment of the purpose for which the data was collected. Your data will be transferred to the different wholesale companies with which the entity operates, as well as to airlines, hotel establishments, car rental companies and/or tour operators, where applicable, for the purpose of contracting their services or requesting information on availability and prices. These providers, depending on the country of your travel destination, may be located in countries that do not have a similar level of data protection to that existing in the EU, for which the transfer is necessary for the purpose of executing contractual measures. They may also be transferred to other companies with which RUTAS MEIGAS SL works/collaborates in order to carry out the corresponding procedures and/or services. Other data will not be transferred to third parties except in cases where there is a legal obligation. RUTAS MEIGAS SL will not elaborate any type of 'profile' based on the information provided. No automated decisions will be made on the basis of profiles.
      Rights: You may exercise your rights of access, rectification, deletion, opposition, limitation of processing, data portability and the right not to be subject to automated individualised decisions, in relation to the data being processed, before the data controller at the address RÚA LISBOA 16 BAJO IZDA - 15707 - SANTIAGO DE COMPOSTELA or by e-mail to info@rutasmeigas.com, attaching a copy of your ID card or equivalent document. In the event that you have not obtained satisfaction in the exercise of your rights, you may lodge a complaint with the competent Data Protection Control Authority, which is the Spanish Data Protection Agency, whose contact details are available at https://sedeagpd.gob.es/sede-electronica-web/vistas/formNuevaReclamacion/reclamacion.jsf`
    },

    ir_al_camino: 'More details of the Camino',

    enviar_consulta: 'Send',
    texto_consulta_agencia: 'Send us your query and we will contact you as soon as possible.',
    consulta_enviada: 'We have received your query, we will contact you as soon as possible. Thank you!',

    
 
  
  },
  
}
